module.exports = __webpack_public_path__ + "static/img/4areaA_8.fdfff7b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/4areaA_8.png
// module id = 913
// module chunks = 1